<template>
  <v-container class="container">
    <div class="div">
      <h1 class="primary--text mb-6 mainHeading">Vilkår for bruk</h1>
      <p>Sist endret: 04.10.2019</p>
      <h3 class="accent--text title mb-2 mt-4">Innledning</h3>
      <p>Takk for at du bruker nettsiden vår, Dine Oppskrifter</p>
      <h3 class="accent--text title mb-2 mt-4">Tjenesten vår</h3>
      <p>
        Via Dine Oppskrifter(tjenesten) kan du lage oppskrifter, enten for deg selv eller gjøre dem offentlig slik at alle kan se dem.
        Du kan justere antall porsjoner du vil ha for enhver oppskrift.
        Du kan også se alle oppskrifter som andre har valgt å offentliggjøre, og filtrere dem, slik at du finner den rette oppskriften for deg.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Gjeldene vilkår</h3>
      <p>
        Din bruk av tjenesten er underlagt disse vilkårene samt
        <router-link to="/personvern-erklaering">Personvernerklæringen</router-link>.
      </p>
      <p>
        Les nøye gjennom denne avtalen, og sørg for at du forstår den. Dersom du ikke forstår hva avtalen innebærer kan du
        <router-link to="#kontakt">kontakte oss</router-link>. Dersom det er deler av den du ikke kan godta, kan du ikke bruke tjenesten.
      </p>
      <h2 class="secondary--text headline mb-4 mt-8">Din bruk av tjenesten</h2>
      <h3 class="accent--text title mb-2 mt-4">Innhold i tjenesten</h3>
      <p>
        Tjenesten omfatter bilder, tekst, interaktive funksjoner, programvare, beregninger og annet materiell(samlet omtalt som "innhold").
        Brukerne kan laste opp innhold til tjenesten og distribuere det, og Dine Oppskrifter er en tilbyder av vertstjenester for dette innholdet.
        Det er personen som laster opp innholdet til tjeneste, som er ansvarlig for det.
        Hvis du ser innhold du mener ikke overholder disse vilkårene, kan du
        <router-link to="/tilbakemelding">rapportere det til oss</router-link>.
      </p>
      <h4 class="info--text subtitle-2 mb-2 mt-4">Konto</h4>
      <p>
        Du kan bruke deler av tjenesten, som å bla gjennom innhold, uten å ha en konto hos oss.
        Noen funksjoner krever imidlertid at du har en konto.
        Dersom du har en konto, kan du opprette oppskrifter, favorisere oppskrifter, med mer.
        For å lage konto logger du enkelt inn med Facebook, og en konto blir opprettet automatisk
      </p>
      <h3 class="accent--text title mb-2 mt-4">Informasjonen din</h3>
      <p>
        Vår
        <router-link to="/personvern-erklaering" class="mr-1">personvernerklæring</router-link>forklarer hvordan vi behandler personopplysningene dine, og hvordan vi beskytter personvernet ditt når du bruker tjenesten.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Tillatelser og begrensninger</h3>
      <p>
        Du gis tilgang til og kan bruke tjenesten slik den er gjort tilgjengelig for deg,
        men dette forutsetter at du overholder denne avtalen samt gjeldene lov og rett.
        Du kan se på innhold til personlig, ikke-kommersiell bruk.
      </p>Følgende begrensninger gjelder for bruken din av tjenesten. Du har ikke lov til å
      <ol>
        <li>
          omgå, slå av eller bruke Tjenesten til svindlersk aktivitet eller på annen måte påvirke Tjenesten (eller forsøke å gjøre noen av disse tingene),
          inkludert sikkerhetsrelaterte funksjoner eller funksjoner som har til formål å
          (a) forhindre eller begrense kopiering eller annen bruk av Innhold eller (b) begrense bruken av Tjenesten eller innhold
        </li>
        <li>
          skaffe deg tilgang til Tjenesten via automatiske virkemidler (f.eks. roboter, botnettverk eller skrapere) med mindre dette gjøres
          (a) i forbindelse med offentlige søkemotorer,
          (b) med skriftlig forhåndstillatelse fra Dine Oppskrifter eller
          (c) i samsvar med gjeldende lov
        </li>
        <li>
          samle inn eller bruke informasjon som kan identifisere enkeltindivider (f.eks. ved å samle inn brukernavn)
          med mindre den aktuelle personen har gitt tillatelse til det eller det er tillatt i henhold til punkt (2) ovenfor
        </li>
        <li>bruke Tjenesten til å distribuere kampanje- eller reklameinnhold til personer som ikke har bedt om det, eller uønskede forespørsler eller masseforespørsler (spam)</li>
        <li>
          bruke Tjenesten til å (a) selge annonsering, sponsing eller promoteringer som er plassert på, i eller rundt Tjenesten eller Innholdet, eller
          (b) selge annonsering, sponsing eller promoteringer på sider i apper eller på nettsteder der Innholdet utelukkende er hentet fra Tjenesten,
          eller der Innhold fra Tjenesten utgjør hovedgrunnlaget for slike salg (for eksempel salg av annonser på nettsider der oppskrifter fra Dine Oppskrifter er det eneste Innholdet av verdi)
        </li>
      </ol>
      <h3 class="accent--text title mb-2 mt-4">Forbehold</h3>
      <p>
        Enhver rettighet du ikke uttrykkelig er gitt i denne avtalen, skal tilfalle Dine Oppskrifter eller de respektive rettighetsinnehaverne.
        Dette betyr blant annet at bruk av tjenesten ikke gir deg eierskap til noen immaterielle rettigheter knyttet til innholdet du får tilgang til.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Endringer i tjenesten</h3>
      <p>
        Dine Oppskrifter jobber kontinuerlig med å endre tjenesten og gjøre den enda bedre. Det kan også være nødvendig for oss å endre eller avikle tjenesten, helt eller delvis, for å forbedre sikkerheten og ytelsen, endre funksjonalitet og funksjoner, implementere endringer for å overholde lov og rett eller forebygge ulovlig aktivitet i eller uriktig bruk av systemene våre.
        Vi vurderer og avveier alltid innvirkningene av slike endringer på bruken av tjenesten.
      </p>
      <h2 class="secondary--text headline mb-4 mt-8">Ditt innhold og din atferd</h2>
      <h3 class="accent--text title mb-2 mt-4">Opplasting av inhold</h3>
      <p>
        Dersom du har konto, kan du laste opp innhold til tjenesten.
        Hvis du velger å laste opp innhold, må du ikke laste opp innhold som er i strid med denne avtalen eller gjeldene lovgivning.
        For eksempel må innholdet du laster opp ikke omfatte tredjeparters immaterielle rettigheter (slik som opphavsrettslig beskyttet materiale),
        med mindre du har innhentet tillatelse fra de aktuelle partene eller på andre måter er juridisk berettiget til å gjøre dette.
        Du står selv juridistk ansvarlig for innholder du laster opp til tjenesten.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Rettigheter du gir til andre</h3>
      <p>Du beholder selv alle eierrettigheter til innholdet ditt. Det som tilhører deg, forblir kort og godt ditt. Vi krever imidlertid at du gir visse rettigheter til Dine Oppskrifter og andre brukere av tjenesten som beskrevet nedenfor.</p>
      <h3 class="accent--text title mb-2 mt-4">Lisens til Dine Oppskrifter</h3>
      <p>
        Når du laster opp innhold til tjenesten, gir du Dine Oppskrifter en ikke-eksklusiv, royaltyfri, overførbar og viderelisensierbar lisens til å bruke dette innholdet (blant annet til å reprodusere,
        distribuere, endre, vise og fremføre det) for formålet om å drifte, promotere og forbedre tjenesten.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Lisens til andre brukere</h3>
      <p>
        Du gir dessuten de andre brukerne av tjenesten en ikke-eksklusiv og royaltyfri lisens til å få tilgang til innholdet ditt via tjenesten,
        og til å bruke innholdet (inkludert å reprodusere, distribuere, endre, vise og fremføre det) kun slik det er gjort mulig i tjenesten.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Lisensens varighet</h3>
      <p>
        Lisensene du innvilger, løper frem til innholdet blir fjernet i tråd med beskrivelsene nedenfor.
        Lisensene opphører så fort du fjerner innholdet, bortsett fra i tilfeler der driften av tjenesten, bruk av innhold tillat før fjerning eller gjeldene lovgivning krever noe annet.
        For eksempel vil fjerning av innhold ikke medføre at Dine Oppskrifter må (a) tilbakekalle innhold som andre bruker, eller (b) slette kopier vi med rimelighet er nødt til å beholde av juridiske årsaker.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Fjerning av innholdet ditt</h3>
      <p>
        Du kan når som helst fjerne ditt eget innhold fra tjenesten.
        Du må fjerne innholdet ditt hvis du ikke lenger innehar rettighetene som kreves i henhold til disse vilkårene.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Dine Oppskrifter sin fjerning av innhold</h3>
      <p>
        Hvis vi har rimelig grunn til å tro at innhold ikke er i samsvar med denne avtalen eller kan være skadelig for Dine Oppskrifter, brukerne våre eller tredjeparter,
        kan vi fjerne hele eller deler av det aktuelle innholdet. Vi vil varsle deg om årsaken bak tiltaket vi har iverksatt, med mindre vi med rimelighet mener at det kan
        (a) bryte loven eller et pålegg fra en rettslig myndighet eller på andre måter risikere å utsette Dine Oppskrifter for juridisk ansvar,
        (b) sette en etterforskning, integriteten til eller driften av tjensesten i fare eller (c) påføre brukere, andre tredjeparter eller Dine Oppskrifter skade.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Opphavsrettsbeskyttelse</h3>
      <p>
        Dersom du mener at opphavsretten din er krenket i tjenesten, ber vi om at du
        <router-link to="/tilbakemelding">kontakter oss</router-link>.
      </p>
      <h2 class="secondary--text headline mb-4 mt-8">Suspensjon og oppsigelse av konto</h2>
      <h3 class="accent--text title mb-2 mt-4">Oppsigelser iverksatt av deg</h3>
      <p>
        Du kan når som helst slutte å bruke tjenesten. Du kan også slette all informasjon om deg og ditt inhold, ved å
        <router-link to="/tilbakemelding">kontakte oss</router-link>.
      </p>
      <h3
        class="accent--text title mb-2 mt-4"
      >Oppsigelser og suspensjoner iverksatt av Dine Oppskrifter av rimelige årsaker</h3>
      <p>
        Dine Oppskrifter kan suspendere eller si opp tilgangen din, kontoen din eller kontoen din sin tilgang til hele eller deler av tjenesten hvis
        (a) du står bak alvorlige eller gjentatte brudd på denne avtalen, (b) vi er forpliktet til å gjøre dette for å kunne overholde juridiske krav eller rettskjennelser eller
        (c) vi har rimelig grunn til å tro at det har forekommet atferd som har påført brukere, andre tredjeparter eller Dine Oppskrifter skade eller juridisk ansvar.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Varsel om oppsigelse eller suspensjon</h3>
      <p>
        Vi vil varsle deg om årsaken bak oppsigelsen eller suspensjonen Dine Oppskrifter har iverksatt, med mindre vi med rimelighet mener at det kan
        (a) bryte loven eller et pålegg fra en rettslig myndighet eller på andre måter risikere å utsette oss selv for juridisk ansvar,
        (b) sette en etterforskning av, integriteten til eller driften av tjenesten i fare eller
        (c) påføre brukere, andre tredjeparter eller Dine Oppskrifter skade. Hvis Dine Oppskrifter fjerner tilgangen din på grunn av endringer i tjenesten, gis du,
        hvis det med rimelighet lar seg gjøre, tilstrekkelig med til til å eksportere innholdet ditt fra tjenesten.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Effekten av kontosuspensjon eller -oppsigelse</h3>
      <p>
        Hvis kontoen din blir sagt opp eller kontoens tilgang til tjenesten begrenses, kan du fortsette å bruke visse deler av tjenesten(for eksempel bare se innhold) uten å ha konto,
        og denne avtalen vil fortsette å gjelde for slik bruk.
        Hvis du mener at kontoen din er sagt opp ved en feil, kan du
        <router-link to="/kontakt">kontakte oss</router-link>.
      </p>
      <h2 class="secondary--text headline mb-4 mt-8">Andre juridiske vilkår</h2>
      <h3 class="accent--text title mb-2 mt-4">Garanti</h3>
      <p>Vi tilbyr tjenesten med rimelig omhu og dyktighet.</p>
      <h3 class="accent--text title mb-2 mt-4">Ansvarsfraskrivelse</h3>
      <p>
        I henhold til loven har forbrukere visse rettigheter som ikke kan settes til side eller endres gjennom kontrakt.
        Ingenting i denne avtalen skal påvirke de rettighetene du måtte ha som forbruker. Dine Oppskrifter gir ingen spesifikke løfter vedrørende tjenesten
        utover det som uttrykkelig fremfår i denne avtalen eller er påkrevd ved lov.
        Vi gir for eksempel ingen løfter om innholdet som leveres via tjenesten,
        de bestemte funksjonene i tjenesten eller tjenestens nøyaktighet, pålitelighet, tilgjengelighet eller egnethet til å oppfylle behovene du måtte ha,
        eller at innholdet du sender inn, blir tilgjengelig eller lagret i tjenesten.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Ansvarsbegrensning</h3>
      <p>
        Alle brukere: Det er ingenting i denne avtalen som er ment å eksludere eller begrense noen av partenes ansvar for
        død eller personskade, svindel, falske fremstillinger eller ansvar som i henhold til loven ikke kan ekskluderes eller begrenses.
      </p>
      <p>I den grad gjeldende lovgivning tillater det, er ikke Dine Oppskrifter ansvarlig for</p>
      <ul>
        <li>tap som ikke er forårsaket av brudd på denne avtalen fra Dine Oppskrifter</li>
        <li>eventuelle tap eller skader som, på tidspunktet da denne avtalen ble inngått mellom Dine Oppskrifter og deg, ikke var en rimelig forutsigelig konsekvens av brudd på denne avtalen fra Dine Oppskrifter</li>
        <li>innhold som er sendt inn av brukere, eller ærekrenkende, støtende eller ulovlig atferd fra brukernes side</li>
      </ul>
      <h3 class="accent--text title mb-2 mt-4">Tredjepartslinker</h3>
      <p>
        Tjenesten kan inneholde linker til tredjeparters nettsteder eller nettjenester som verken eies eller kontrolleres av Dine Oppskrifter.
        Dine Oppskrifter har ingen kontroll over, og påtar seg ikke ansvar for, slike nettsteder og nettjenester. Vær oppmerksom når du forlater tjenesten.
        Vi anbefaler at du leser gjennom vilkårene og personvernerklæringen for alle tredjepartsnettsteder og nettjenestene du besøker.
      </p>
      <h2 class="secondary--text headline mb-4 mt-8">Om denne avtalen</h2>
      <h3 class="accent--text title mb-2 mt-4">Avtaleendringer</h3>
      <p>
        Vi kan komme til å endre denne avtalen, blant annet for å gjenspeile endringer i tjenesten eller av juridiske, reguleringsmessige eller sikkerhetsrelaterte årsaker.
        Endringene trer i kraft med umiddelbar virkning, og det vil det komme frem på forsiden neste gang du besøker den.
      </p>
      <h3 class="accent--text title mb-2 mt-4">Videreføring av avtalen</h3>
      <p>
        Hvis du slutter å bruke tjenesten, vil følgende vilkår i denne avtalen fortsette å gjelde for deg:
        "Andre juridiske vilkår", "Om denne avtalen" og i tillegg vil lisensene du har gitt til andre fortsatt gjelde i de avgrensede tilfellene som er beskrevet under "Lisensens varighet".
      </p>
      <h3 class="accent--text title mb-2 mt-4">Atskilt ugyldighet</h3>
      <p>Hvis en del av vilkårene i denne avtalen ikke kan håndheves, uansett grunn, påvirker ikke dette resten av vilkårene.</p>
      <h3 class="accent--text title mb-2 mt-4">Overdragelse</h3>
      <p>Dine Oppskrifter kan overføre enhver del av eller hele denne avtalen til en samarbeidspartner eller, dersom Dine Oppskrifter kjøpes opp, til en tredjepart.</p>
      <h3 class="accent--text title mb-2 mt-4">Ingen fraskrivelse</h3>
      <p>
        Hvis du ikke overholder denne avtalen og vi ikke iverksetter umiddelbare tiltak,
        betyr ikke det at vi fraskriver oss eventuelle rettigheter vi måtte inneha
        (f. eks. retten til å iverksette fremtidige tiltak).
      </p>
      <h2 class="secondary--text headline mb-4 mt-8">Kontakt oss</h2>
      <p>
        Dersom du har spørsmål knyttet til denne avtalen eller noe annet tilknyttet Dine Oppskrifter, kan du sende en e-post til
        <a
          href="mailto:brukerstotte@dine-oppskrifter.no"
        >brukerstotte@dine-oppskrifter.no</a> eller besøke
        <router-link class="mr-1" to="/kontakt-oss">kontakt oss siden</router-link>for flere måter å kontakte oss.
      </p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "termsOfService",
  metaInfo() {
    return {
      title: "Vilkår for bruk - Dine Oppskrifter"
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
  display: flex;
  justify-content: center;
}

.div {
  max-width: 1200px;
}

.mainHeading {
  font-size: 1.9rem;
  font-weight: 400;
}

@media only screen and (min-width: 800px) {
  .div {
    margin: 30px;
  }
}
</style>